/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// THE FIRM FLAGS THAT DECIDE WHICH CHECKS APPLY TO A CASE (v1_813, shared v1_827).
// Every surface that reconciles a case (the board, the flow map, the review
// report, the exports, the Jaybee report and review, the officer assistant)
// passes these, read live from the firm, so they all count the same checks.
// Without them the case state falls back to collected_data.firmFeatures, the
// copy the client portal saved when the client last used it: empty for a
// migrated case, stale after a flag changes.
export const CASE_FEATURE_KEYS = Object.freeze(['sanctions', 'sumsub', 'chainalysis', 'travel_rule', 'sow_interviews', 'require_aml_policy', 'require_intermediary_screening']);

export function caseFeatures(features) {
  const ff = features && typeof features === 'object' ? features : {};
  return Object.fromEntries(CASE_FEATURE_KEYS.filter((k) => k in ff).map((k) => [k, ff[k]]));
}
